/*!
 * doTERRA CRM
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */


/*******************************/
/** United States             **/
/*******************************/
const USMarket = {

    regions: [
        {name: "Alabama", isocodeShort: "AL", isocode: "US-AL"},
        {name: "Alaska", isocodeShort: "AK", isocode: "US-AK"},
        {name: "Arizona", isocodeShort: "AZ", isocode: "US-AZ"},
        {name: "Arkansas", isocodeShort: "AR", isocode: "US-AR"},
        {name: "California", isocodeShort: "CA", isocode: "US-CA"},
        {name: "Colorado", isocodeShort: "CO", isocode: "US-CO"},
        {name: "Connecticut", isocodeShort: "CT", isocode: "US-CT"},
        {name: "Delaware", isocodeShort: "DE", isocode: "US-DE"},
        {name: "Federated States of Micronesia", isocodeShort: "FM", isocode: "US-FM"},
        {name: "Florida", isocodeShort: "FL", isocode: "US-FL"},
        {name: "Georgia", isocodeShort: "GA", isocode: "US-GA"},
        {name: "Hawaii", isocodeShort: "HI", isocode: "US-HI"},
        {name: "Idaho", isocodeShort: "ID", isocode: "US-ID"},
        {name: "Illinois", isocodeShort: "IL", isocode: "US-IL"},
        {name: "Indiana", isocodeShort: "IN", isocode: "US-IN"},
        {name: "Iowa", isocodeShort: "IA", isocode: "US-IA"},
        {name: "Kansas", isocodeShort: "KS", isocode: "US-KS"},
        {name: "Kentucky", isocodeShort: "KY", isocode: "US-KY"},
        {name: "Louisiana", isocodeShort: "LA", isocode: "US-LA"},
        {name: "Maine", isocodeShort: "ME", isocode: "US-ME"},
        {name: "Marshall Islands", isocodeShort: "MH", isocode: "US-MH"},
        {name: "Maryland", isocodeShort: "MD", isocode: "US-MD"},
        {name: "Massachusetts", isocodeShort: "MA", isocode: "US-MA"},
        {name: "Michigan", isocodeShort: "MI", isocode: "US-MI"},
        {name: "Minnesota", isocodeShort: "MN", isocode: "US-MN"},
        {name: "Mississippi", isocodeShort: "MS", isocode: "US-MS"},
        {name: "Missouri", isocodeShort: "MO", isocode: "US-MO"},
        {name: "Montana", isocodeShort: "MT", isocode: "US-MT"},
        {name: "Nebraska", isocodeShort: "NE", isocode: "US-NE"},
        {name: "Nevada", isocodeShort: "NV", isocode: "US-NV"},
        {name: "New Hampshire", isocodeShort: "NH", isocode: "US-NH"},
        {name: "New Jersey", isocodeShort: "NJ", isocode: "US-NJ"},
        {name: "New Mexico", isocodeShort: "NM", isocode: "US-NM"},
        {name: "New York", isocodeShort: "NY", isocode: "US-NY"},
        {name: "North Carolina", isocodeShort: "NC", isocode: "US-NC"},
        {name: "North Dakota", isocodeShort: "ND", isocode: "US-ND"},
        {name: "Ohio", isocodeShort: "OH", isocode: "US-OH"},
        {name: "Oklahoma", isocodeShort: "OK", isocode: "US-OK"},
        {name: "Oregon", isocodeShort: "OR", isocode: "US-OR"},
        {name: "Palau", isocodeShort: "PW", isocode: "US-PW"},
        {name: "Pennsylvania", isocodeShort: "PA", isocode: "US-PA"},
        {name: "Rhode Island", isocodeShort: "RI", isocode: "US-RI"},
        {name: "South Carolina", isocodeShort: "SC", isocode: "US-SC"},
        {name: "South Dakota", isocodeShort: "SD", isocode: "US-SD"},
        {name: "Tennessee", isocodeShort: "TN", isocode: "US-TN"},
        {name: "Texas", isocodeShort: "TX", isocode: "US-TX"},
        {name: "Utah", isocodeShort: "UT", isocode: "US-UT"},
        {name: "Vermont", isocodeShort: "VT", isocode: "US-VT"},
        {name: "Virginia", isocodeShort: "VA", isocode: "US-VA"},
        {name: "Washington", isocodeShort: "WA", isocode: "US-WA"},
        {name: "West Virginia", isocodeShort: "WV", isocode: "US-WV"},
        {name: "Wisconsin", isocodeShort: "WI", isocode: "US-WI"},
        {name: "Wyoming", isocodeShort: "WY", isocode:"US-WY"},
        {name: "Northern Mariana Islands", isocodeShort: "MP", isocode: "US-MP"},
        {name: "Guam", isocodeShort: "GU", isocode: "US-GU"},
        {name: "District of Columbia", isocodeShort: "DC", isocode: "US-DC"},
        {name: "American Samoa", isocodeShort: "AS", isocode: "US-AS"},
        {name: "Puerto Rico", isocodeShort: "PR", isocode: "US-PR"},
        {name: "United States Minor Outlying Islands", isocodeShort: "UM", isocode: "US-UM"},
        {name: "United States Virgin Islands", isocodeShort: "VI", isocode: "US-VI"},
        {name: "Armed Forces Africa, Canada, Europe, Middle East (AE)", isocodeShort: "AE", isocode: "US-AE"},
        {name: "Armed Forces Pacific (AP)", isocodeShort: "AP", isocode: "US-AP"},
        {name: "Armed Forces Americas (AA)", isocodeShort: "AA", isocode:"US-AA"}
    ],
    formats: {
        postalCode: {
            pattern: '\\d{5}(?:-\\d{4})?$',
            mask: 'NNNNN[-NNNN]',
            restrictedPattern: '\\d{5}',
            restrictedMask: 'NNNNN',
            maxLength: 10,
            example: '12345 or 12345-6789'
        },
        currency: {
            symbol: '$',
            scale: 2,
            currencyCode: 'USD'
        }
    },
    countryName: {
        en: "United States",
        es: "Estados Unidos",
        zh: "美国",
        fr: "États Unis"
    },
    ccType: [
        {name: "Mastercard", key: "master"},
        {name: "Visa", key: "visa"},
        {name: "American Express", key: "amex"},
        {name: "Discover", key: "discover"},
        {name: "Diner's Club", key: "diners"},
        {name: "JCB", key: "jcb"},
        {name: "Union Pay", key: "unionpay"}
    ]

};


/*******************************/
/** Canada                    **/
/*******************************/
const CA_PCG_1 = 'ABCEGHJKLMNPRSTVXY';
const CA_PCG_2 = 'ABCEGHJKLMNPRSTVWXYZ';

const CAMarket = {
    regions: [
        {iscode: "CA-AB", name: "Alberta", isocodeShort: "AB"},
        {iscode: "CA-BC", name: "British Columbia", isocodeShort: "BC"},
        {iscode: "CA-MB", name: "Manitoba", isocodeShort: "MB"},
        {iscode: "CA-NB", name: "New Brunswick", isocodeShort: "NB"},
        {iscode: "CA-NL", name: "Newfoundland and Labrador", isocodeShort: "NL"},
        {iscode: "CA-NS", name: "Nova Scotia", isocodeShort: "NS"},
        {iscode: "CA-NT", name: "Northwest Territories", isocodeShort: "NT"},
        {iscode: "CA-NU", name: "Nunavut", isocodeShort: "NU"},
        {iscode: "CA-ON", name: "Ontario", isocodeShort:"ON"},
        {iscode: "CA-PE", name: "Prince Edward Island", isocodeShort: "PE"},
        {iscode: "CA-QC", name: "Quebec", isocodeShort: "QC"},
        {iscode: "CA-SK", name: "Saskatchewan", isocodeShort: "SK"},
        {iscode: "CA-YT", name: "Yukon", isocodeShort: "YT"}
    ],
    formats: {
        postalCode: {
            pattern: `([${CA_PCG_1}|${CA_PCG_1.toLowerCase()}][0-9][${CA_PCG_2}|${CA_PCG_2.toLowerCase()}] [0-9][${CA_PCG_2}|${CA_PCG_2.toLowerCase()}][0-9])`,
            mask: 'ANA NAN',
            maxLength: 7,
            example: "A4C 9K4",
            upperCase: true
        },
        currency: {
            symbol: '$',
            scale: 2,
            currencyCode: 'CAD'
        }
    },
    countryName: {
        fr: "Canada",
        en: "Canada",
        es: "Canadá",
        zh: "加拿大"
    },

    ccType: [
        {name: "Mastercard", key: "master"},
        {name: "Visa", key: "visa"},
        {name: "American Express", key: "amex"},
        {name: "Discover", key: "discover"},
        {name: "Union Pay", key: "unionpay"}
    ]
};

/*********************************/
/*********Australia***************/
/*********************************/
const AUMarket = {
    regions: [
        {iscode: "AU-ACT", name: "Australian Capital Territory", isocodeShort: "ACT"},
        {iscode: "AU-NSW", name: "New South Wales", isocodeShort: "NSW"},
        {iscode: "AU-NT ", name: "Northern Territory", isocodeShort: "NT"},
        {iscode: "AU-QLD", name: "Queensland", isocodeShort: "QLD"},
        {iscode: "AU-SA ", name: "South Australia", isocodeShort: "SA"},
        {iscode: "AU-TAS", name: "Tasmania", isocodeShort: "TAS"},
        {iscode: "AU-VIC", name: "Victoria", isocodeShort: "VIC"},
        {iscode: "AU-WA", name: "Western Australia", isocodeShort: "WA"}
    ],
    formats: {
        postalCode: {
            pattern: '\\d{4}$',
            mask: 'NNNN',
            maxLength: 4,
            example: "1234"
        },
        currency: {
            symbol: '$',
            scale: 2,
            currencyCode: 'AUD'
        }
    },
    countryName: {
        fr: "Australia",
        en: "Australia",
        es: "Australia",
        zh: "Australia"
    },

    ccType: [
        {name: "Mastercard", key: "master"},
        {name: "Visa", key: "visa"},
        {name: "American Express", key: "amex"}
    ]
};

const NZMarket = {
    regions: [
     {iscode: "NZ-AUK", name: "Auckland", isocodeShort: "AUK"},
        {iscode: "NZ-BOP", name: "Bay of Plenty", isocodeShort: "BOP"},
        {iscode: "NZ-CAN", name: "Canterbury", isocodeShort: "CAN"},
        {iscode: "NZ-CIT", name: "Chatham Islands", isocodeShort: "CIT"},
        {iscode: "NZ-GIS", name: "Gisborne", isocodeShort: "GIS"},
        {iscode: "NZ-HKB", name: "Hawke´s Bay", isocodeShort: "HKB"},
        {iscode: "NZ-MWT", name: "Manawatu-Wanganui", isocodeShort: "MWT"},
        {iscode: "NZ-MBH", name: "Marlborough", isocodeShort: "MBH"},
        {iscode: "NZ-NSN", name: "Nelson", isocodeShort: "NSN"},
        {iscode: "NZ-NTL", name: "Northland", isocodeShort: "NTL"},
        {iscode: "NZ-OTA", name: "Otago", isocodeShort: "OTA"},
        {iscode: "NZ-STL", name: "Southland", isocodeShort: "STL"},
        {iscode: "NZ-TKI", name: "Taranaki", isocodeShort: "TKI"},
        {iscode: "NZ-TAS", name: "Tasman", isocodeShort: "TAS"},
        {iscode: "NZ-WKO", name: "Waikato", isocodeShort: "WKO"},
        {iscode: "NZ-WTC", name: "West Coast", isocodeShort: "WTC"},
        {iscode: "NZ-WGN", name: "Wellington", isocodeShort: "WGN"}
    ],
    formats: {
        postalCode: {
             pattern: '\\d{4}$',
             mask: 'NNNN',
            maxLength: 4,
            example: "0000"
        },
        currency: {
            symbol: 'NZ $',
            scale: 2,
            currencyCode: 'NZD'
        }
    },
    countryName: {
        fr: "New Zealand",
        en: "New Zealand",
        es: "New Zealand",
        zh: "New Zealand"
    },

    ccType: [
        {name: "Mastercard", key: "master"},
        {name: "Visa", key: "visa"}
    ]
};

const marketData = {
    US: USMarket,
    CA: CAMarket,
    AU: AUMarket,
    NZ: NZMarket
};

export const getSupportedRegions = (language) => {
    return Object.keys(marketData).reduce((result, key)=>{
        result.push({
            value: key,
            name: marketData[key].regions
        });
        return result;
    },[]);
};

export const getSupportedCCTypes = (language) => {
    return Object.keys(marketData).reduce((result, key)=>{
        result.push({
            value: key,
            name: marketData[key].ccType
        });
        return result;
    },[]);
};


/*******************************/
/** Common (exports)          **/
/*******************************/
export const getMarketData = (market) => {
    return marketData[market];
};

export const getSupportedCountryNames = (language, markets) => {
    const marketList = markets ? markets.split(",") : [];
    return Object.keys(marketData).reduce((result, key)=>{
        marketList.map((country) => {
            if(country === key) {
                result.push({
                    value: key,
                    name: marketData[key].countryName[language]
                });
            }
        });
        return result;
    },[]);
};

export const getFormatter = (market, name) => {
    market = getMarketData(market);
    if (!market || !market.formats) {
        return undefined;
    }
    return market.formats[name] || undefined;
};

export const convertRegionToIsocode = (market, region) => {
    if (region.length === 2) {
        return region.toUpperCase();
    }
    market = getMarketData(market.toUpperCase());
    if (!market || !market.regions) {
        return undefined;
    }
    const test = market.regions.filter(a => a.name.toLowerCase() === region.toLowerCase());
    return test[0].isocodeShort;
};
